import { config } from "../shared/config"

export interface ParentConfig {
  tag: "portal"
}

export const getTokenFromParent = (): Promise<string | null> =>
  new Promise<string | null>((resolve) => {
    const listener = (event: MessageEvent): void => {
      if (config().isAllowedOrigin(event.origin)) {
        const { type, token } = event.data
        if (type === `SEND_AUTH_TOKEN`) {
          if (token !== undefined) {
            window.removeEventListener(`message`, listener, false)
            resolve(token)
            return
          }
          resolve(null)
        }
      }
    }

    window.addEventListener(`message`, listener, false)
    window.parent.postMessage({ type: `REQUEST_AUTH_TOKEN` }, `*`)
  })
